import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import SumListField from 'portaltransparencia-common/components/SumListField.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

const MESES = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
];

const MAP_TIPO_REPASSE = {
  R: {
    labelColuna: 'Valor Recebido'
  },
  E: {
    labelColuna: 'Valor Repassado'
  }
};

export class RepasseDetalhe extends Component {
  static propTypes = {
    repasses: PropTypes.object.isRequired,
    tipo: PropTypes.oneOf(['E', 'R']).isRequired,
    mesInicial: PropTypes.number,
    mesFinal: PropTypes.number
  };

  getValorMes = (mes, campo) => {
    const { repasses, mesInicial = 1, mesFinal = 12 } = this.props;
    if (mes < mesInicial || mes > mesFinal) return null;
    const item = repasses.find(r => r.get('mes') === mes);
    return item ? item.get(campo) : null;
  };

  renderMes = (nomeMes, mesNum) => {
    return (
      <tr key={mesNum}>
        <td>{nomeMes}</td>
        <td className="right">
          <NumberFormatter value={this.getValorMes(mesNum, 'valorPrevisto')} />
        </td>
        <td className="right">
          <NumberFormatter value={this.getValorMes(mesNum, 'valorRecebido')} />
        </td>
        <td className="right">
          <NumberFormatter value={this.getValorMes(mesNum, 'valorDevolvido')} />
        </td>
      </tr>
    );
  };

  render() {
    const { repasses, tipo, mesInicial = 1, mesFinal = 12 } = this.props;
    const config = MAP_TIPO_REPASSE[tipo] || { labelColuna: 'Valor Realizado' };
    const repassesFiltrados = repasses.filter(
      r => r.get('mes') >= mesInicial && r.get('mes') <= mesFinal
    );

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader width="100%">
            <tr>
              <th>Mês</th>
              <th style={{ textAlign: 'right' }}>Valor Previsto</th>
              <th style={{ textAlign: 'right' }}>{config.labelColuna}</th>
              <th style={{ textAlign: 'right' }}>Valor Devolvido</th>
            </tr>
          </TableHeader>
          <tbody>
            {MESES.map((nome, idx) => this.renderMes(nome, idx + 1))}
          </tbody>
          <tfoot>
            <tr>
              <td>
                <i>Total</i>
              </td>
              <td className="right">
                <SumListField
                  fieldName="valorPrevisto"
                  list={repassesFiltrados}
                />
              </td>
              <td className="right">
                <SumListField
                  fieldName="valorRecebido"
                  list={repassesFiltrados}
                />
              </td>
              <td className="right">
                <SumListField
                  fieldName="valorDevolvido"
                  list={repassesFiltrados}
                />
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }
}

export default RepasseDetalhe;
